import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useAddTypeObjectMutation, useDeleteTypeObjectMutation, useEditTypeObjectMutation } from "../../../../redux/api/handBooksApi/typeObjectApi";
import { EntDirectoryInfoName } from "../../../../models/directoryInfoName";
import { getCookie } from "typescript-cookie";

const useTypeObject = (modal: any, refresh?: () => void) => { 
    const { t } = useTranslation();
    const { confirm } = modal;
    const [addTypeObject] = useAddTypeObjectMutation();  
    const [deleteTypeObject] = useDeleteTypeObjectMutation(); 
    const [editTypeObject] = useEditTypeObjectMutation(); 

    async function onAddTypeObject(newTypeObject: EntDirectoryInfoName): Promise<boolean> {  
        try {
            let status: boolean = false;
            await addTypeObject(newTypeObject).then((response: any) => {  
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }

    async function onDeleteTypeObject(typeObject: EntDirectoryInfoName) {  // Заменено на onDeleteTypeObject
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteTypeObject(typeObject.id as number).then((response: any) => {  // Заменено на deleteTypeObject
                        if (response.error) {
                            const isKyrgyz = getCookie('i18next') === 'ky';
                            const lang = isKyrgyz ? 'kg' : 'ru';
                            const res = response.error.data?.res;
                            const errorMessages = Array.isArray(res)
                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                : response.error.data?.msg || t('unknownError'); 
                            throw new Error(errorMessages);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({ title: t('msg.successDelete') });
                            if(refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                    });
                }
            })
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    async function onEditTypeObject(editedTypeObject: EntDirectoryInfoName): Promise<boolean> {  // Заменено на onEditTypeObject
        try {
            let status: boolean = false;
            await editTypeObject(editedTypeObject).then((response: any) => {  // Заменено на editTypeObject
                 if (response.error) {
                                             const isKyrgyz = getCookie('i18next') === 'ky';
                                             const lang = isKyrgyz ? 'kg' : 'ru';
                                             const res = response.error.data?.res;
                                             const errorMessages = Array.isArray(res)
                                                 ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                 : response.error.data?.msg || t('unknownError'); 
                                             throw new Error(errorMessages);
                                         }
                if (response.data.success) {
                    status = true;
                    Modal.success({ title: t('msg.successEdited') });
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    return { onAddTypeObject, onDeleteTypeObject, onEditTypeObject };  // Заменено на onAddTypeObject, onDeleteTypeObject, onEditTypeObject
}

export { useTypeObject };  // Заменено на useTypeObject
